export enum AvatarColors {
  Blue,
  Yellow,
  Red,
}
